import { render, staticRenderFns } from "./InstructorDetailsModal.vue?vue&type=template&id=949e1572&scoped=true&"
import script from "./InstructorDetailsModal.vue?vue&type=script&lang=js&"
export * from "./InstructorDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949e1572",
  null
  
)

export default component.exports